// 初始化状态
const initState = {
  // 列表数据
  tableInfo: {
    list: [] as any[],
    total: 0
  }
}

// 定义 action 类型
type Props = {
  type: 'A1/getList'
  payload: { list: any[]; total: number }
}

// reducer
export default function Reducer(state = initState, action: Props) {
  switch (action.type) {
    // 获取列表数据
    case 'A1/getList':
      return { ...state, tableInfo: action.payload }

    default:
      return state
  }
}
